import { render } from "./payWithSaldo.vue?vue&type=template&id=22b2d87a&ts=true"
import script from "./payWithSaldo.vue?vue&type=script&lang=ts"
export * from "./payWithSaldo.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__